export default function Hero() {
  const scrollToProducts = () => {
    const element = document.getElementById('productos');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center text-white overflow-hidden">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/26d710e5ea7f8557e333051d113e9f68.jpg')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      
      <div className="text-center max-w-6xl mx-auto px-4 relative z-10 pt-20">
        <div className="relative z-10 text-center max-w-5xl mx-auto px-4">
          <div className="mb-6">
            <span className="bg-gradient-to-r from-cyan-500/20 to-blue-500/20 backdrop-blur-xl border border-cyan-500/30 text-cyan-300 px-6 py-3 rounded-full text-sm font-medium">
              ✨ Experiencias Náuticas de Lujo en Los Cabos
            </span>
          </div>
          
          <h1 className="text-6xl md:text-8xl font-bold mb-8 leading-tight font-playfair">
            <span className="bg-gradient-to-r from-white via-cyan-100 to-white bg-clip-text text-transparent">
              RENTA DE LANCHAS YATES
            </span>
            <br />
            <span className="bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
              EN CABO SAN LUCAS
            </span>
            <br />
            <span className="text-4xl md:text-6xl bg-gradient-to-r from-teal-400 to-emerald-400 bg-clip-text text-transparent">
              MAR AZUL
            </span>
          </h1>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <button 
            onClick={scrollToProducts}
            className="font-semibold rounded-full transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg relative overflow-hidden bg-gradient-to-r from-cyan-500 to-blue-600 text-white hover:from-cyan-400 hover:to-blue-500 px-8 py-4 text-lg shadow-2xl"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full hover:translate-x-full transition-transform duration-700"></div>
            <span className="relative z-10 flex items-center justify-center">
              <i className="ri-ship-line mr-2"></i>Explorar Flota
            </span>
          </button>
          <button 
            onClick={scrollToContact}
            className="font-semibold rounded-full transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap shadow-lg relative overflow-hidden bg-gradient-to-r from-teal-500 to-emerald-600 text-white hover:from-teal-400 hover:to-emerald-500 px-8 py-4 text-lg shadow-2xl"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full hover:translate-x-full transition-transform duration-700"></div>
            <span className="relative z-10 flex items-center justify-center">
              <i className="ri-calendar-check-line mr-2"></i>Reservar Ahora
            </span>
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
        <i className="ri-arrow-down-s-line text-3xl"></i>
      </div>
    </section>
  );
}